import { closest } from 'fastest-levenshtein';

const findClosestMatch = (query = '', list = []) => {
  return closest(query, list) ?? null;
};

export default findClosestMatch;
